import React, { useState } from 'react';
import { Sticky, StickyContainer } from 'react-sticky';

import styled from 'styled-components';

const DesktopCTA = styled.div`
  z-index: 10;
  display: none;
  @media (min-width: 992px) {
    display: inherit;
  }
  margin-top: 180px;
  width: 410px;

  .desktop-cta-fixed {
    padding: 30px;
    margin-left: 70px;
    width: 340px;
    background: white;
    border: 1px solid #e3e5ea;
    h1 {
      font-weight: 700;
      font-size: 20px;
      color: #2e3035;
    }
    p {
      margin-top: 20px;
      font-weight: 400;
      font-size: 16px;
      line-height: 160%;
      color: #62656a;
    }
    select {
      margin-top: 30px;
      width: 100%;
      color: #62656a;
      font-size: 16px;
      height: 46px;
      background-position-y: 10px;
    }
    a {
      margin-top: 20px;
      display: block;
      width: 100%;
      text-align: center;
      font-size: 18px;
      height: 50px;
    }
  }
`;

const MobileCTA = styled.div`
  z-index: 13;
  @media (min-width: 992px) {
    display: none;
  }
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 74px;
  width: 100%;
  padding: 12px 20px;
  background: white;
  border-top: 1px solid #e3e5ea;
  .btn {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 18px;
  }
`;

const ModalContent = styled.div`
  div.selector {
    padding-bottom: 20px;
    select {
      width: 100%;
      font-size: 16px;
      padding: 11px 14px;
    }
  }
  div.divider {
    margin: 0 -14px;
    border-bottom: 1px solid #e3e5ea;
    margin-bottom: 12px;
  }

  .btn {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 18px;
  }
`;

const PartnerCTA: React.FC = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <DesktopCTA>
        <StickyContainer>
          <Sticky topOffset={-80}>
            {({ style, distanceFromBottom }) => (
              <div
                className="desktop-cta-fixed"
                style={{
                  ...style,
                  width: '340px',
                  top: 180,
                  ...(distanceFromBottom < 200 ? { top: distanceFromBottom - 50 } : {}),
                }}
              >
                <h1>파트너가 맘에 드시나요?</h1>
                <p>
                  지금 바로 미소앱에서
                  <br />
                  무료 견적 4개를 받아보세요.
                </p>
                <a className="btn" href={'https://get.miso.kr/aIELyACciGb'}>
                  앱 다운 받기
                </a>
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </DesktopCTA>
      <MobileCTA>
        <a className="btn" href={'https://get.miso.kr/aIELyACciGb'}>
          앱에서 견적 받기
        </a>
      </MobileCTA>
    </>
  );
};

export default PartnerCTA;
